import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import { apiError, guarantorLogSuccessful } from "./guarantorLogSlice";
import { getParamsList } from "../../../helpers/Helper";

function* GuarantorLogList({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          if (k === "start_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else if (k === "end_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else {
            params[k] = data[k];
          }
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/attendance/guarantorlog/", params);
    yield put(guarantorLogSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchGetGuarantorLog() {
  yield takeEvery("guarantorLog/getGuarantorLog", GuarantorLogList);
}

function* guarantorLogSaga() {
  yield all([fork(watchGetGuarantorLog)]);
}

export default guarantorLogSaga;
